"use client";
import { jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { SliderContext } from "../helpers/SliderContext.mjs";
const Tooltips = ({ className }) => {
  const {
    format,
    values,
    range,
    prefixLabel,
    suffixLabel,
    rtl: appliedRTL
  } = useContext(SliderContext);
  const tooltipFormat = (val) => `${appliedRTL ? suffixLabel : prefixLabel}${format.to(val)}${appliedRTL ? prefixLabel : suffixLabel}`;
  const tooltipPosition = values.length > 1 ? `${normalizeValue((values[0] + values[1]) * 0.5, range)}%` : `${normalizeValue(values[0], range)}%`;
  const tooltipLabel = values.length > 1 ? `${tooltipFormat(values[0])} \u2013 ${tooltipFormat(values[1])}` : tooltipFormat(values[0]);
  return /* @__PURE__ */ jsx("div", { className, children: /* @__PURE__ */ jsx(Tooltip, { tooltipLabel, tooltipPosition }) });
};
const normalizeValue = (value, { min, max }) => 100 * (value - min) / (max - min);
const Tooltip = ({
  tooltipLabel,
  tooltipPosition
}) => {
  const { prefix, rtl } = useContext(SliderContext);
  const divRef = React.useRef(null);
  let halfWidth = "0px";
  if (typeof window !== "undefined") {
    halfWidth = `${((divRef.current ? divRef.current.getBoundingClientRect().width - 24 : 0) * 0.5).toFixed(1)}px`;
  }
  const rightBound = `min(${tooltipPosition}, 100% - ${halfWidth})`;
  const leftRightBound = `max(${rightBound}, ${halfWidth})`;
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: divRef,
      className: `${prefix}slider-tooltip`,
      style: { [rtl ? "right" : "left"]: leftRightBound },
      children: `${tooltipLabel}`
    }
  );
};
var Tooltips_default = Tooltips;
export {
  Tooltips_default as default
};
